import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { PayInResource } from './types';

export default (makeCall: MakeCall) => (settlementReference: string) =>
  makeCall<{ payins: PayInResource[] }>(
    'GET',
    `/api/v2/payment/settlement/${settlementReference}/pay-in`,
  );
